import BaseUseCase from "../../../base_use_case.js";

class DeleteProjectUseCase extends BaseUseCase {

  execute(identifier) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "delete",
      url: `/api/v1/admin/projects/projects/${identifier}`,
      params: {
        findBySlug: true
      },
    });
  }
}

const instance = new DeleteProjectUseCase();
export default instance;